import { useDispatch } from "react-redux";
import { useSetDefaultWorkspaceMutation } from "../store/api";
import { setWorkspace } from "../store/workspaces";
export const useHandleSetDefaultWorkspace = () => {
    const dispatch = useDispatch();
    const [setDefaultWorkspace] = useSetDefaultWorkspaceMutation();
    const handleSetDefaultWorkspace = async (currentWorkspace) => {
        const workspaceForRedux = {
            ...currentWorkspace,
            isDefault: true
        };
        await setDefaultWorkspace({
            isDefault: true,
            isHidden: currentWorkspace.isHidden ?? false,
            orderNumber: currentWorkspace.orderNumber,
            workspaceId: currentWorkspace.id
        });
        dispatch(setWorkspace(workspaceForRedux));
    };
    return { handleSetDefaultWorkspace };
};
